module.exports = __webpack_public_path__ + "images/Loader Round65d0aa7dbbe24d93505a83323c297430.svg";